import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GuestCheckoutOption = () => {
  const benefits = [
    'Exclusive beauty deals and discounts',
    'Personalized product recommendations',
    'Order history and tracking',
    'Wishlist and favorites',
    'Early access to new arrivals',
    'Style tips and tutorials'
  ];

  return (
    <div className="mt-8 space-y-6">
      {/* Guest Checkout */}
      <div className="p-6 bg-muted/50 rounded-xl border border-border">
        <div className="text-center">
          <Icon name="ShoppingBag" size={32} className="text-primary mx-auto mb-3" />
          <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
            Continue as Guest
          </h3>
          <p className="text-sm text-muted-foreground mb-4">
            Shop without creating an account. You can always register later.
          </p>
          <Link to="/shopping-cart">
            <Button variant="outline" iconName="ArrowRight" iconPosition="right">
              Continue to Checkout
            </Button>
          </Link>
        </div>
      </div>
      {/* Registration Benefits */}
      <div className="p-6 bg-accent/10 rounded-xl border border-accent/20">
        <div className="text-center mb-4">
          <Icon name="Sparkles" size={32} className="text-accent mx-auto mb-3" />
          <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
            Join Lalay Fashion Today
          </h3>
          <p className="text-sm text-muted-foreground">
            Unlock exclusive benefits and enhance your fashion shopping experience
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-center space-x-2">
              <Icon name="Check" size={16} className="text-success flex-shrink-0" />
              <span className="text-sm text-foreground">{benefit}</span>
            </div>
          ))}
        </div>
        
        <div className="text-center">
          <Link to="/user-registration">
            <Button iconName="UserPlus" iconPosition="left">
              Create Free Account
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GuestCheckoutOption;